import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import DivDerivativePanel from './components/DivDerivativePanel';

import {getLanguage} from '../../util/localStorage';
import {FORM_DERIVATIVE_PLAIN, } from '../../util/consts/forms';
import {CLASS_DERIVATIVE, } from '../../util/consts/classes';

class DerivativePlainPage extends PlainPage {
	
	constructor(props) {
		super(props);
		this.formPath = FORM_DERIVATIVE_PLAIN;
		this.formTitle = 'Екранізація';
		this.buildInstanceCard = this.buildDerivativeCard;
	}
	componentDidMount = async () => {
		this.init(CLASS_DERIVATIVE)
		document.title = 'BOM. ' + this.formTitle;
	}

	buildDerivativeCard = (derivativeInstance) => {
		let card = '';
		
		if(derivativeInstance.rootField.value.derivativeInfo.value.length > 0) {
			let currentLanguage = getLanguage();
			let info = null;
			for(let inf of derivativeInstance.rootField.value.derivativeInfo.value) {
				if( inf.value.language.value == currentLanguage && inf.value.name.value ) {
					info = inf;
					break;
				}
			}
			if( info == null ) {
				for(let inf of derivativeInstance.rootField.value.derivativeInfo.value) {
					if( inf.value.name.value ) {
						info = inf;
						break;
					}
				}
			}			
			if( info )
				card = info.value.name.value
		}
		
		if( ! card ) {
			for(let f of derivativeInstance.rootField.value.images.value) {
				if( f.value.resourceName.value ) {
					card = f.value.resourceName.value;
					break;
				}
			}
		}
		
		return card;
	}

	renderBody() {
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<DivDerivativePanel plain={this} instance={instance} isPlain={true} readOnly={readOnly} />
				</div>
			</div>
		)
	}
}

export default DerivativePlainPage;
